import { buildNameColumnFromObject } from '@@/datatables/buildNameColumn';

import { Credential } from '../../../types';

import { provider } from './provider';

export const columns = [
  buildNameColumnFromObject<Credential>({
    nameKey: 'name',
    path: 'portainer.settings.sharedcredentials.credential',
    dataCy: 'cloud-credentials-name',
    idParam: 'id',
    idGetter: (row) => row.id.toString(),
    linkParamsBuilder: (row) => ({ providerType: row.provider }),
  }),
  provider,
];
